@if (true) {
    <div class="modal-body">
        <form [formGroup]="addContactEvent" (ngSubmit)="onContactSubmit(addContactEvent.value);">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="ContactType" class="form-label">Contact Type <span class="text-danger">*</span> </label>
                                <ng-select
                                    [items]="ContactType"
                                    bindLabel="SubDescr"
                                    bindValue="SubID"
                                    formControlName="ContactType"
                                    placeholder="Select Contact Type"
                                    [clearable]="false">
                                    <ng-option *ngIf="!ContactType?.length" [value]="''">Select Contact Type</ng-option>
                                </ng-select>
                                @if (f.ContactType.touched && f.ContactType.invalid) {
                                    @if (f.ContactType.errors.required) {
                                        <span class="text-danger">Contact Type is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Department" class="form-label"> <a href="{{RouteGMDesignation}}" target="_blank">Designation</a></label>
                                <ng-select
                                    [items]="Designation"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="ContactDesignation"
                                    (change)="onContactDesignationSelect($event)"
                                    placeholder="Select Designation">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                    <ng-option [value]="'-1'">Other</ng-option>
                                    <ng-option *ngFor="let mDtl of Designation" [value]="mDtl.hdID">{{ mDtl.MainDescr }}</ng-option>
                                </ng-select>
                                @if (f.ContactDesignation.touched && f.ContactDesignation.invalid) {
                                    @if (f.ContactDesignation.errors.required) {
                                        <span class="text-danger">Designation is required.</span>
                                    }
                                }
                                @if (ADDContactDesignationType == "Text") {
                                    <input class="form-control mt-2" formControlName="ADDContactDesignation" type="text"
                                        placeholder="Enter Designation" name="ContactDesignation">
                                    @if (f.ADDContactDesignation.touched && f.ADDContactDesignation.invalid) {
                                        @if (f.ADDContactDesignation.errors.required) {
                                            <span class="text-danger">Designation is required.</span>
                                        }
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Department" class="form-label"><a href="{{RouteGMDepartment}}" target="_blank">Department</a></label>
                                <ng-select
                                [items]="Department1"
                                bindLabel="MainDescr"
                                bindValue="hdID"
                                formControlName="ContactDepartment"
                                (change)="onContactDepartmentSelect($event)"
                                placeholder="Select Department">
                                <ng-option [value]="'0'">Not Selected</ng-option>
                                <ng-option [value]="'-1'">Other</ng-option>
                                <ng-option *ngFor="let mDtl of Department1" [value]="mDtl.hdID">{{ mDtl.MainDescr }}</ng-option>
                                </ng-select>
                                @if (f.ContactDepartment.touched && f.ContactDepartment.invalid) {
                                    @if (f.ContactDepartment.errors.required) {
                                        <span class="text-danger">Department is required.</span>
                                    }
                                }
                            </div>
                            @if (ADDContactDepartmentType == 'Text') {
                                <input class="form-control" formControlName="ADDContactDepartment" type="text"
                                    placeholder="Enter Department" name="ContactDepartment">
                            }
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Title" class="form-label">Title</label>
                                 <ng-select
                                    [items]="[
                                    { id: '0', label: 'Mr.' },
                                    { id: '1', label: 'Ms.' },
                                    { id: '2', label: 'Mrs.' },
                                    { id: '3', label: 'Dr.' }
                                    ]"
                                    bindLabel="label"
                                    bindValue="id"
                                    formControlName="ContactTitle"
                                    placeholder="Select Title"
                                    [clearable]="false">
                                    <ng-option [value]="'0'">Mr.</ng-option>
                                    <ng-option [value]="'1'">Ms.</ng-option>
                                    <ng-option [value]="'2'">Mrs.</ng-option>
                                    <ng-option [value]="'3'">Dr.</ng-option>
                                </ng-select>
                                @if (f.ContactTitle.touched && f.ContactTitle.invalid) {
                                    @if (f.ContactTitle.errors.required) {
                                        <span class="text-danger">Title is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Name" class="form-label">Name</label>
                                <input class="form-control" formControlName="ContactName" type="text"
                                    placeholder="Enter Name" name="ContactName">
                                @if (f.ContactName.touched && f.ContactName.invalid) {
                                    @if (f.ContactName.errors.required) {
                                        <span class="text-danger">Name is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="CustomerCode" class="form-label">Customer Code</label>
                                <input class="form-control" formControlName="ContactCustomerCode" type="text"
                                    placeholder="Enter Customer Code" name="ContactCode">
                                @if (f.ContactCustomerCode.touched && f.ContactCustomerCode.invalid) {
                                    @if (f.ContactCustomerCode.errors.required) {
                                        <span class="text-danger">Customer Code is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Mobile" class="form-label">Mobile No</label>
                                <input class="form-control" formControlName="ContactMobile" type="number"
                                    placeholder="Enter Mobile No" name="ContactMobile">
                                @if (f.ContactMobile.touched && f.ContactMobile.invalid) {
                                    @if (f.ContactMobile.errors.required) {
                                        <span class="text-danger">Mobile No is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="ContactPhone" class="form-label">Contact No</label>
                                <input class="form-control" formControlName="ContactPhone" type="number"
                                    placeholder="Enter Contact No" name="ContactPhone">
                                @if (f.ContactPhone.touched && f.ContactPhone.invalid) {
                                    @if (f.ContactPhone.errors.required) {
                                        <span class="text-danger">Contact No is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Email" class="form-label">Email ID</label>
                                <input class="form-control" formControlName="ContactEmail" type="email"
                                    placeholder="Enter Email" name="ContactEmail">
                                @if (f.ContactEmail.touched && f.ContactEmail.invalid) {
                                    @if (f.ContactEmail.errors.required) {
                                        <span class="text-danger">Valid Email ID is required.</span>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
               @if (RightsID.includes('202034001') || RightsID.includes('202034021')) {
                   <div class="d-flex justify-content-center mt-3">
                   <button class="btn btn-primary submit-btn small" type="submit">
                       Add
                   </button>
               </div>
               }
        </form>
    </div>
}@else {
    <!-- <div class="modal-body  col-sm-12 form-group">
        <form #AddContact="ngForm" [formGroup]="addContactEvent" (ngSubmit)="onContactSubmit(AddContact.value);">
                <div class="form-group mt-2" style="display:none;">
                    <div class="form-check">
                        <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                            [(ngModel)]="options.autoClose">
                        <label for="autoClose">Auto close alert after three seconds</label>
                    </div>
        
                </div>
        
                <div class="col-sm-4 height-34">Contact Type</div>
                <div class="col-sm-5">
                    <ng-select
                        [items]="ContactType"
                        bindLabel="SubDescr"
                        bindValue="SubID"
                        formControlName="ContactType"
                        placeholder="Select Contact Type"
                        [clearable]="false">
                        <ng-option *ngIf="!ContactType?.length" [value]="''">Not Selected</ng-option>
                    </ng-select>
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
        
                <div class="col-sm-4 height-34"><a href="{{RouteGMDesignation}}" target="_blank">Designation</a></div>
                <div class="col-sm-5">
                    <ng-select
                        [items]="Designation"
                        bindLabel="MainDescr"
                        bindValue="hdID"
                        formControlName="ContactDesignation"
                        (change)="onContactDesignationSelect($event)"
                        placeholder="Not Selected">
                        <ng-option [value]="'0'">Not Selected</ng-option>
                        <ng-option [value]="'-1'">Other</ng-option>
                        <ng-option *ngFor="let mDtl of Designation" [value]="mDtl.hdID">{{ mDtl.MainDescr }}</ng-option>
                    </ng-select>
                </div>
                <div class="col-sm-3"><input class="form-control" formControlName="ADDContactDesignation"
                        type={{ADDContactDesignationType}} placeholder="Enter Designation" name="ContactDesignationy"></div>
                <div class="col-sm-12">
                    <hr>
                </div>
        
                <div class="col-sm-4 height-34"><a href="{{RouteGMDepartment}}" target="_blank">Department</a></div>
                <div class="col-sm-5">
                    <ng-select
                        [items]="Department1"
                        bindLabel="MainDescr"
                        bindValue="hdID"
                        formControlName="ContactDepartment"
                        (change)="onContactDepartmentSelect($event)"
                        placeholder="Not Selected">
                        <ng-option [value]="'0'">Not Selected</ng-option>
                        <ng-option [value]="'-1'">Other</ng-option>
                        <ng-option *ngFor="let mDtl of Department1" [value]="mDtl.hdID">{{ mDtl.MainDescr }}</ng-option>
                    </ng-select>
                </div>
                <div class="col-sm-3"><input class="form-control" formControlName="ADDContactDepartment"
                        type={{ADDContactDepartmentType}} placeholder="Enter Department" name="ContactDepartmenty"></div>
                <div class="col-sm-12">
                    <hr>
                </div>
                <div class="col-sm-4 height-34">Title</div>
                <div class="col-sm-5">
                    <ng-select
                        [items]="[
                          { id: '0', label: 'Mr.' },
                          { id: '1', label: 'Ms.' },
                          { id: '2', label: 'Mrs.' },
                          { id: '3', label: 'Dr.' }
                        ]"
                        bindLabel="label"
                        bindValue="id"
                        formControlName="ContactTitle"
                        placeholder="Not Selected"
                        [clearable]="false">
                        <ng-option [value]="'0'">Mr.</ng-option>
                        <ng-option [value]="'1'">Ms.</ng-option>
                        <ng-option [value]="'2'">Mrs.</ng-option>
                        <ng-option [value]="'3'">Dr.</ng-option>
                    </ng-select>
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
        
                <div class="col-sm-4 height-34">Name</div>
                <div class="col-sm-5">
                    <input class="form-control" formControlName="ContactName" placeholder="Enter Name" name="ContactName"
                        type="text" value="">
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
                <div class="col-sm-4 height-34">Customer Code</div>
                <div class="col-sm-5">
                    <input class="form-control" formControlName="ContactCustomerCode" placeholder="Enter Customer Code"
                        name="CustomerCode" type="text" value="">
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
                <div class="col-sm-4 height-34">Mobile No</div>
                <div class="col-sm-5">
                    <input class="form-control" formControlName="ContactMobile" placeholder="Enter Mobile No"
                        name="ContactMobile" type="text" value="">
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
                <div class="col-sm-4 height-34">Contact No</div>
                <div class="col-sm-5">
                    <input class="form-control" formControlName="ContactPhone" placeholder="Enter Contact No"
                        name="ContactPhone" type="text" value="">
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
        
                <div class="col-sm-4 height-34">Email ID</div>
                <div class="col-sm-5"><input class="form-control" formControlName="ContactEmail" placeholder="Enter Email Id"
                        name="ContactEmail" type="email" value=""></div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
                <div class="col-sm-12">&nbsp;</div>
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-5">
                <div class="form-group col-sm-4"
                    *ngIf="this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ; then AddContactLink else AddContactNoLink">
                </div>
                <ng-template #AddContactLink>
                    <input class="btn btn-primary col-sm-12" type="submit" value="ADD">
                </ng-template>
                <ng-template #AddContactNoLink>
                    &nbsp;
                </ng-template>
            </div>
            <div class="col-sm-3"></div>
            <div class="form-group mt-2" style="display:none;">
                <div class="form-check">
                    <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                        [(ngModel)]="options.autoClose">
                    <label for="autoClose">Auto close alert after three seconds</label>
                </div>
    
            </div>
            <div class="jumbotron p-4">
                <div class="container text-center col-sm-4 alertCssforPopup">
                    <app-alert></app-alert>
                    <router-outlet></router-outlet>
                </div>
            </div>
    
        </form>
    </div>    -->
}